/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Inquiry Info lazy load
 *
 * @author Julia Ignatieva
 * @version 1.15.0
 * @since 1.15.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./components/InquiryInfoPage'));
